export const MESSAGE_FILTER_CACHE_FIELDS = [
    'anyOf', 'schedule', 'imageColor', 'text', 'folderId', 'type', 'isTrash', 'sortBy', 'searchMode',
    'dateFrom', 'dateTo', 'isStarred', 'isTask', 'isDone', 'sourceHosts', 'sourceTypes',
    'stackIds', 'entityTypes', 'hasChat', 'hasThreadMessages', 'onlyFolderChats'
];

export const buildVisibilityAwareKeyArgs = (baseFields = []) => args => {
    const data = args?.data || {};
    const resolved = {};
    baseFields.forEach(field => { resolved[field] = data[field]; });
    resolved.includeThreadMessages = data.includeThreadMessages !== false;
    resolved.includeChatMessages = data.includeChatMessages !== false;
    resolved.includeFolderChats = data.includeFolderChats === true;
    return JSON.stringify(resolved);
};
